module.exports = __webpack_public_path__ + "img/4-3.16b97c55.jpg";